import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["productId", "ratingsSummary"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Flex, Heading, Tab, TabList, TabPanel, Tabs } from "@catchoftheday/cg-components";
import { useMarkReviewHelpfulMutation, useProductReviewsQuery } from "@product-app/generated/graphql";
import { reviewTabs } from "../../consts";
import { ReviewList } from "./ReviewList";
import { ReviewStatistics } from "./ReviewStatistics";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var NewReviews = function NewReviews(_ref) {
  var productId = _ref.productId,
      ratingsSummary = _ref.ratingsSummary,
      boxProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(Array.from({
    length: 6
  }, function () {
    return {
      offset: 0,
      reviews: []
    };
  })),
      reviews = _useState[0],
      setReviews = _useState[1];

  var _useState2 = useState(0),
      selectedTabIndex = _useState2[0],
      setSelectedTabIndex = _useState2[1];

  var limit = 6;

  var _useProductReviewsQue = useProductReviewsQuery({
    variables: {
      productId: productId,
      offset: 0,
      limit: limit,
      rating: reviewTabs[selectedTabIndex] > 0 ? reviewTabs[selectedTabIndex] : undefined
    },
    notifyOnNetworkStatusChange: true,
    ssr: false
  }),
      data = _useProductReviewsQue.data,
      loading = _useProductReviewsQue.loading,
      refetch = _useProductReviewsQue.refetch;

  var _useMarkReviewHelpful = useMarkReviewHelpfulMutation({
    fetchPolicy: "no-cache"
  }),
      _useMarkReviewHelpful2 = _slicedToArray(_useMarkReviewHelpful, 1),
      updateHelpfulReview = _useMarkReviewHelpful2[0];

  var handleUpdateHelpfulReview = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reviewId, helpfulCountAdjustment, setRequiresAuth, setHelpfulReviews, setLoading) {
      var _yield$updateHelpfulR, data, customerHelpfulFeedback;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return updateHelpfulReview({
                variables: {
                  input: {
                    reviewId: reviewId,
                    helpfulCountAdjustment: helpfulCountAdjustment
                  }
                }
              });

            case 3:
              _yield$updateHelpfulR = _context.sent;
              data = _yield$updateHelpfulR.data;
              setLoading(false);

              if ((data === null || data === void 0 ? void 0 : data.markReviewHelpful.__typename) == "UnauthorisedUserError") {
                setRequiresAuth(true);
              } else if ((data === null || data === void 0 ? void 0 : data.markReviewHelpful.__typename) == "ProductReview") {
                customerHelpfulFeedback = data === null || data === void 0 ? void 0 : data.markReviewHelpful.helpful.customerHelpfulFeedback;
                setHelpfulReviews(function (prevState) {
                  if (prevState.customerHelpfulFeedback !== customerHelpfulFeedback) {
                    return _objectSpread(_objectSpread({}, prevState), {}, {
                      customerHelpfulFeedback: customerHelpfulFeedback
                    });
                  }

                  return prevState;
                });
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }(), [updateHelpfulReview]);

  function setSelectedTab(tabIndex) {
    setSelectedTabIndex(tabIndex);

    if (reviews[tabIndex].reviews.length === 0) {
      getMoreReviews();
    }
  }

  var updateReviews = useCallback(function (response) {
    setReviews(function (prevReviews) {
      var reviews = _toConsumableArray(prevReviews);

      reviews[selectedTabIndex].reviews = _toConsumableArray(reviews[selectedTabIndex].reviews.concat(response));
      return reviews;
    });
  }, [selectedTabIndex]);
  var updateOffset = useCallback(function () {
    setReviews(function (prevReviews) {
      var reviews = _toConsumableArray(prevReviews);

      reviews[selectedTabIndex].offset = reviews[selectedTabIndex].offset + limit;
      return reviews;
    });
  }, [selectedTabIndex]);
  var getMoreReviews = useCallback(function (offset) {
    refetch({
      offset: offset
    });

    if (offset) {
      updateOffset();
    }
  }, [refetch, updateOffset]);
  var reviewsExists = useMemo(function () {
    return function (response) {
      var exists = false;
      reviews[selectedTabIndex].reviews.forEach(function (value) {
        if (response.find(function (item) {
          return item.id == value.id;
        })) {
          exists = true;
          return;
        }
      });
      return exists;
    };
  }, [reviews, selectedTabIndex]);
  useEffect(function () {
    var _data$productReviews;

    var response = data === null || data === void 0 ? void 0 : (_data$productReviews = data.productReviews) === null || _data$productReviews === void 0 ? void 0 : _data$productReviews.reviews;

    if (response !== null && response !== void 0 && response.length && !reviewsExists(response)) {
      updateReviews(response);
    }
  }, [data, updateReviews, reviewsExists]);
  useEffect(function () {
    setSelectedTabIndex(ratingsSummary.breakdown.findIndex(function (item) {
      return item.total > 0;
    }));
  }, [ratingsSummary.breakdown]);
  return ___EmotionJSX(Box, _extends({}, boxProps, {
    backgroundColor: "white",
    borderRadius: 16,
    px: {
      _: 4,
      lg: 10
    },
    pt: {
      _: 6,
      lg: 10
    },
    pb: 4
  }), ___EmotionJSX(Heading.h2, {
    m: "0",
    fontSize: "2xl",
    lineHeight: "1"
  }, "Reviews"), ___EmotionJSX(Flex, {
    flexWrap: "nowrap",
    flexDirection: {
      xs: "column",
      lg: "row"
    },
    gap: 2,
    mt: 4
  }, ___EmotionJSX(Box, {
    width: {
      _: "100%",
      lg: "25%"
    }
  }, ___EmotionJSX(ReviewStatistics, {
    mt: 0,
    averageRating: ratingsSummary.averageRating,
    reviewCount: ratingsSummary.numberOfRatings,
    summary: ratingsSummary.breakdown,
    setSelectedTab: setSelectedTab
  })), ___EmotionJSX(Box, {
    width: {
      _: "100%",
      lg: "75%"
    }
  }, ___EmotionJSX(Heading.h4, {
    mt: 0,
    mb: 4
  }, "What customers are saying"), ___EmotionJSX(Tabs, {
    selectedIndex: selectedTabIndex,
    onSelect: function onSelect(index) {
      return setSelectedTab(index);
    }
  }, ___EmotionJSX(TabList, {
    display: "none"
  }, reviewTabs.map(function (tab) {
    return ___EmotionJSX(Tab, {
      key: "tab-".concat(tab)
    }, tab == 0 ? "ALL" : "".concat(tab, " STAR"));
  })), reviews.map(function (item, index) {
    var _ratingsSummary$break;

    return ___EmotionJSX(TabPanel, {
      key: index
    }, ___EmotionJSX(ReviewList, {
      reviews: item.reviews.map(function (review) {
        return _objectSpread({}, review);
      }),
      reviewCount: index == 5 ? ratingsSummary.numberOfRatings : (_ratingsSummary$break = ratingsSummary.breakdown[selectedTabIndex]) === null || _ratingsSummary$break === void 0 ? void 0 : _ratingsSummary$break.total,
      onShowMore: function onShowMore() {
        getMoreReviews(item.offset + limit);
      },
      onClickHelpful: handleUpdateHelpfulReview,
      loading: loading
    }));
  })))));
};